export const SettingsTypes = {
  EMAIL_SETTINGS_REQUESTED: "SETTINGS/EMAIL_SETTINGS_REQUESTED",
  GET_EMAIL_SETTINGS_SUCCESS: "SETTINGS/GET_EMAIL_SETTINGS_SUCCESS",
  EMAIL_SETTINGS_FAILURE: "SETTINGS/EMAIL_SETTINGS_FAILURE",
  UPDATE_EMAIL_SETTINGS_SUCCESS: "SETTINGS/UPDATE_EMAIL_SETTINGS_SUCCESS",
};
